const CUR = {
  BRL: ["pt-BR", "BRL"],
  EUR: ["pt-PT", "EUR"],
  USD: ["en-US", "USD"],
  GBP: ["en-GB", "GBP"],
};

export const fmtMoney = (n, currency = "BRL") => {
  const [loc, code] = CUR[currency] || CUR.BRL;
  return (Number(n) || 0).toLocaleString(loc, { style: "currency", currency: code });
};

export const brl = (n) => fmtMoney(n, "BRL");

export const num = (n) => {
  const v = Number(n);
  return isNaN(v) ? 0 : v;
};

export const computeTotals = (data) => {
  const items = data?.items || [];
  const priced = items.filter((it) => !it?.no_price);
  const subtotal = priced.reduce(
    (acc, it) => acc + num(it.quantity) * num(it.unit_price),
    0
  );
  const discount = num(data?.discount);
  const taxRate = num(data?.tax);
  const afterDiscount = Math.max(subtotal - discount, 0);
  const taxValue = afterDiscount * (taxRate / 100);
  const override = num(data?.total_override);
  const total = override > 0 ? override : afterDiscount + taxValue;
  const hasUnpriced = priced.length < items.length;
  const allUnpriced = items.length > 0 && priced.length === 0;
  return { subtotal, discount, taxRate, taxValue, total, override, hasUnpriced, allUnpriced };
};

export const FONT_MAP = {
  sans: "tpl-sans",
  serif: "tpl-serif-head",
  mono: "tpl-mono",
  inter: "font-inter",
  dm: "font-dm",
  syne: "font-syne",
};

export const todayBR = () => {
  const d = new Date();
  return d.toLocaleDateString("pt-BR");
};
